import React from "react";
import {
    Dialog as MuiDialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    Typography,
    Box,
    styled,
} from "@mui/material";
import { ReactComponent as Warning } from "assets/img/warningImage.svg";
import { LoadingButton } from "@mui/lab";

const Dialog = styled(MuiDialog)(({ theme }) => ({
    "& .MuiDialog-container": {
        "& .MuiDialog-paper": {
            maxWidth: "780px",
            padding: "18px 25px",
        },
    },
}));

const AccountMigrateModal = ({ open, onContinue, onClose, isSubmitting }) => {
    return (
        <Dialog open={open} onClose={onClose}>
            <DialogTitle>
                <Box
                    display="flex"
                    alignItems="center"
                    flexDirection={"column"}
                    gap={1}
                    mb={1}
                >
                    <Warning width={70} height={70} />
                    <Typography
                        sx={{ fontSize: "26px", fontWeight: 700, color: "#0f172a" }}
                    >
                        You already have a Kardia account
                    </Typography>
                </Box>
            </DialogTitle>
            <DialogContent sx={{ px: 4 }}>
                We noticed that you already have a Kardia account with us. Confirming
                the upgrade will move your existing details into KardiaComplete. All
                your records will be retained. Would you like to upgrade to
                KardiaComplete?
            </DialogContent>
            <DialogActions>
                <LoadingButton
                    onClick={onContinue}
                    variant="contained"
                    fullWidth
                    loading={isSubmitting}
                >
                    yes, upgrade
                </LoadingButton>
                <Button
                    onClick={onClose}
                    variant="outlined"
                    fullWidth
                    disabled={isSubmitting}
                >
                    no, do not upgrade
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default AccountMigrateModal;
